import Head from 'next/head';
import { PopOver } from '@/components/Popover';

const Page = () => {
  return (
    <>
      <Head>
        <title>Popover</title>
      </Head>

      <h1>Popover</h1>
      <PopOver styles={'btn btn-lg btn-primary w-100'} />
    </>
  );
};

export default Page;
